module.exports = {
  pathPrefix: '/',
  siteTitle: 'Scott Pierce-Wrobel',
  siteTitleAlt: 'Scott Pierce-Wrobel Web Developer Portfolio',
  siteUrl: 'https://scottpierce-wrobel.com/',
  siteLanguage: 'en',
  siteLogo: 'headshot-hero.png',
  siteDescription: 'A DEVELOPER, DESIGNER, HUSBAND and MARINE who enjoys making beautiful websites',
  userTwitter: 'scottpiercew',
  copyright: '© 2018',
  client: 'Client',
  date: 'Date',
  platform: 'platform',
  dateFormat: 'DD.MM.YYYY',
  themeColor: '#21f228',
  backgroundColor: '#2b2e3c',
  headerFontFamily: 'Mina',
  bodyFontFamily: 'Roboto',
  baseFontSize: '16px',
};



// WEBPACK FOOTER //
// ./config/SiteConfig.js